module.exports = __webpack_public_path__ + "static/media/icon-heart.b0b29d3b.svg";